const firebaseConfig = {
  apiKey: "AIzaSyARE4KiKZQdYY_3jed2_TaBKdnfuKj82f4",
  authDomain: "full-stack-001.firebaseapp.com",
  projectId: "full-stack-001",
  storageBucket: "full-stack-001.appspot.com",
  messagingSenderId: "87103651221",
  appId: "1:87103651221:web:e2dba1630f595f66fa0a9c"
};

export default firebaseConfig;